
import dynamic from 'next/dynamic';
import Image from 'next/image';

import {
  Box,
  Hidden,
  Typography
} from '@mui/material';

import { useTheme } from '@mui/material/styles';


const ReactSpeedometer = dynamic(() => import ("react-d3-speedometer"), { ssr: false })


const CostEstimate = ({ service, estimate }) => {
  
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" textAlign="center" position="relative">
      {estimate ? (
        <>
          <Box my={1} display="flex" justifyContent="center">
            <Hidden mdUp>
              <Typography variant="h4">
                <Typography
                  variant="inherit"
                  component="span"
                  sx={{
                    color: 'primary.light',
                    fontWeight: 500,
                  }}
                >
                  Estimate
                </Typography>
                {' for '}
                <br />
                {service}
              </Typography>
            </Hidden>
            <Hidden mdDown>
              <Typography variant="h6">
                <Typography
                  variant="inherit"
                  component="span"
                  sx={{
                    color: 'primary.light',
                    fontWeight: 500,
                  }}
                >
                  Estimate
                </Typography>
                {' for '}
                {service}
              </Typography>
            </Hidden>
          </Box>
          <Box my={2} fontSize="30px" fontWeight={500} overflow="visible">
            R{estimate.estimate_25th} <small style={{ fontWeight: 400 }}>to</small> R
            {estimate.estimate_75th}
          </Box>

          <Box minHeight={220} maxHeight={220}>
            <ReactSpeedometer
              fluidWidth={true}
              minValue={estimate.estimate_min}
              maxValue={estimate.estimate_max}
              value={estimate.estimate_median}
              currentValueText={`R ${estimate.estimate_median}`}
              needleColor={theme.palette.secondary.main}
              segments={10}
              maxSegmentLabels={5}
              startColor={theme.palette.primary.light}
              endColor="#ededed"
              needleTransitionDuration={4000}
              needleTransition="easeElastic"
              needleHeightRatio={0.8}
              valueTextFontSize={'36px'}
              paddingVertical={16}
            />
          </Box>

          <Box fontSize="h6.fontSize" mb={1}>
            Based on{' '}
            <Box display="initial" color="primary.light" fontWeight={600}>
              {estimate.estimate_count}
            </Box>{' '}
            previous quotes
          </Box>
          <Typography variant="body2" color="textSecondary">
            Note: This is just an estimate, continue to receive detailed quotes
          </Typography>
        </>
      ) : (
        <>
          <Box my={1} fontSize="h6.fontSize" fontWeight={500}>
            {service}
          </Box>
          <Box width={200} alignSelf="center" mb={2} mt={1}>
            <Image
              src="/icons/be-the-first.svg"
              width={200}
              height={200}
              alt="Be The First"
              title="Be The First"
            />
          </Box>
          <Typography variant="h6" color="textSecondary">
            No estimate available yet.
            <br />
            Be the first to request quotes
          </Typography>
        </>
      )}
    </Box>
  );
};

export default CostEstimate;
